import { ContentArticleTemplateContext } from '@contexts/content-article-template'
import ContentfulPageSectionGridLayout from '@entries/contentful-page-section-grid-layout'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { ContentfulContentArticleTemplate } from '@typings/contentful-content-article-template'
import { graphql } from 'gatsby'
import React from 'react'

import { ContentType } from './content-types'

const ContentfulPageSectionRecommendation: Utils.EntryFC<
  Queries.ContentfulPageSectionRecommendationFragment
> = ({ content }) => (
  <ContentArticleTemplateContext.Provider
    value={ContentfulContentArticleTemplate.RECOMMENDATION}
  >
    <Entry
      content={content}
      mapping={{
        [ContentType.ContentfulPageSection]: ContentfulPageSectionGridLayout,
      }}
    />
  </ContentArticleTemplateContext.Provider>
)

export const query = graphql`
  fragment ContentfulPageSectionRecommendation on ContentfulSection {
    ...ContentfulEntry
    contents {
      ...ContentfulContentArticle
      ...ContentfulLegacyEtapier
      ...ContentfulWrapperRichMedia
      ...ContentfulReview
      ...ContentfulFaqPageList
    }
  }
`

export default withDisplayName(
  ContentfulPageSectionRecommendation,
  'ContentfulPageSectionRecommendation'
)
